// extracted by mini-css-extract-plugin
module.exports = {"save-button":"save-button_save-button__1VMZX","disabled":"save-button_disabled__2sZA3"};